module.exports = __webpack_public_path__ + "static/media/acc-1.e0a841ca.jpg";